import { Controller } from '@hotwired/stimulus';
import { useIntersection } from 'stimulus-use';
import { get } from '@rails/request.js';

export default class extends Controller {
  static values = { nextMonthUrl: String };

  connect() {
    // 0.8 triggers the fetch a bit before the placeholder fully scrolls into
    // view, so the next month is ready by the time the user reaches the bottom.
    // The placeholder is small enough to always fit within the viewport, so
    // this threshold is reliably reached.
    const [, unobserve] = useIntersection(this, { threshold: 0.8 });
    this.unobserve = unobserve;
  }

  appear() {
    if (this.nextMonthRequested) {
      return;
    }

    this.nextMonthRequested = true;

    get(this.nextMonthUrlValue, { responseKind: 'turbo-stream' })
      .then(() => {
        this.unobserve();
      })
      .catch(() => {
        this.nextMonthRequested = false;
      });
  }
}
